import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=76298a8c&scoped=true&"
import script from "./freight.vue?vue&type=script&lang=js&"
export * from "./freight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76298a8c",
  null
  
)

export default component.exports